import { useMenuContext } from '../../contexts/MenuContext'

export const RestaurantIdToName = restaurantId => {
  const { allRestaurantData } = useMenuContext()
  let index = allRestaurantData?.findIndex(restaurant => restaurant.id == restaurantId)
  return allRestaurantData[index].name
}
